import api from "../config/api";

const store = (data: any) => {
  return api.post("/streamings", data);
};

const stop = (streamingId: any) => {
  return api.post(`/streamings/${streamingId}/stop`);
};

const meeting = (stationId: any) => {
  return api.post(`createmeeting/station/${stationId}`);
};

const show = (streamingId: any) => {
  return api.get(`/streamings/${streamingId}`);
};

const getStreamingsStatusByDebriefing = (debriefingId: any) => {
  return api.get(`/streamings/debriefing/${debriefingId}/status`);
};

const provision = (streamingId: string | number) => {
  return api.post(`/management/streamings/${streamingId}/gcp/provision`)
};

const startChannel = (streamingId: string | number) => {
  return api.post(`/management/streamings/${streamingId}/gcp/channel/start`)
};

const stopChannel = (streamingId: string | number) => {
  return api.post(`/management/streamings/${streamingId}/gcp/channel/stop`)
};

const deprovision = (streamingId: string |number) => {
  return api.delete(`/management/streamings/${streamingId}/gcp/provision`)
};

const StreamingService = {
  store,
  stop,
  meeting,
  show,
  getStreamingsStatusByDebriefing,
  provision,
  startChannel,
  stopChannel,
  deprovision,
};

export default StreamingService;
